import { render, staticRenderFns } from "./recevieList.vue?vue&type=template&id=0f888ad2&scoped=true&"
import script from "./recevieList.vue?vue&type=script&lang=js&"
export * from "./recevieList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f888ad2",
  null
  
)

export default component.exports